<div class="container-fluid ecommerce-kyc-wizard">

    <button (click)="backToOnboarding()" class="back-link" type="button">
        <i class="fa fa-chevron-left fas"></i> Back to Onboarding
    </button>

    <p class="wizard-subtitle">
        A few details to complete your KYC. Your banking details in step 3 are used for AVS verification at the same
        time. </p>

    <div class="card">
        <div class="card-title">
            <div class="mt-4">
                <p-steps [activeIndex]="currentStep" [model]="kycSteps" [readonly]="true"></p-steps>
            </div>
        </div>
        <div class="card-body">
            <div>
                <app-kyc-step1 (nextPage)="processNext()"
                               (profileDetail)="onProfileDetailSubmission($event)"
                               [hidden]="currentStep !== 0"
                               [prefilledProfileDetail]="prefilledProfileDetail"
                               [readOnly]="readOnly"></app-kyc-step1>
                <app-kyc-form (kycDetail)="onKycDetailSubmission($event)"
                              (nextPage)="processNext()"
                              (previousPage)="processPrevious()"
                              [businessTypeSubject]="businessTypeSubject"
                              [hidden]="currentStep !== 1"
                              [natureOfBusiness]="natureOfBusiness"
                              [prefilledKycDetail]="prefilledKycDetail"
                              [readOnly]="readOnly"
                              [skipDuplicateCheckForPrefilled]="true"></app-kyc-form>
                <div [hidden]="currentStep !== 2">
                    <div class="avs-info-banner">
                        <i class="fas fa-info-circle"></i> <strong>AVS verification.</strong> Your banking details are
                        used for Account Verification Services (AVS) at the same time as your KYC check — you don't need
                        to start it separately.
                    </div>
                    <app-avs-form (bankingDetail)="onBankingDetailsSubmission($event)"
                                  (nextPage)="processNext()"
                                  (previousPage)="processPrevious()"
                                  [prefilledBankDetail]="prefilledBankDetail"
                                  [readOnly]="readOnly"></app-avs-form>
                </div>
                <app-address-form (addressDetail)="onAddressDetailSubmission($event)"
                                  (previousPage)="processPrevious()"
                                  [hidden]="currentStep !== 3"
                                  [prefilledAddressDetail]="prefilledAddressDetail"
                                  [readOnly]="readOnly"
                                  [submitting]="submitting"
                                  submitLabel="Submit for verification"></app-address-form>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
